<template>
  <div class="list-rest">
    <VoteCounterMobile
      :votesAll="numberOfVotesCast"
      :votesDone="numberOfUsedVotes"
      v-on:sendVotes="sendAllVotes"
      v-if="!indexOfStart && numberOfVotesCast && canVote"
    />
    <div
      class="list-rest__list"
      v-for="(listItem, index) in songsList"
      :key="index"
    >
      <div
        class="list-rest__waiting-room"
        v-if="showWaitingRoom(listItem, index)"
      >
        Poczekalnia
      </div>
      <div
        class="list-rest__waiting-room"
      v-if="showLucky13(listItem, index)"
      >
        Szczęśliwa trzynastka
      </div>
      <div
        :class="!indexOfStart ? 'list-rest__single-list-element vote-list' : 'list-rest__single-list-element' "
        v-if="showFirstElement(index)"
      >
        <div
          class="list-rest__index"
          :class="{secondFirst: listItem.position === 1}"
          v-if="listItem.position"
          tabindex="0"
          :aria-label="'Miejsce numer'+listItem.position"
        >
          {{listItem.position}}
        </div>
        <div
          class="list-rest__index"
          v-if="!listItem.position"
          tabindex="0"
          :aria-label="'Numer'+(index+1)"
        >
          {{index+1}}
        </div>
        <div
          class="list-rest__photo"
          v-if="indexOfStart && listNumber !== '11'"
          @click="console(listItem)"
        >
          <div
            class="list-rest__photo-content"
            :class="{photoContentWithoutPhoto: !listItem.artists[0].photo}"
            v-bind:style="{ backgroundImage: 'url(' + listItem.artists[0].photo + ')' }"
          >
            <div
              class="list-rest__photo-content-new"
              v-if="listItem.isNew && listNumber !== '11'"
            >
              nowość
            </div>
          </div>
        </div>
        <div :class="!indexOfStart ? 'list-rest__info vote-list' : 'list-rest__info' ">
          <div class="list-rest__info-content">
            <div class="list-rest__song-info">
              <div
                class="list-rest__info-artist"
                @click="()=>{goToArtistSite(listItem.artists[0].id)}"
              >
                <p v-if="listItem.artists[0].displayedName && !indexOfStart">{{listItem.artists[0].displayedName}}</p>
                <p v-else>{{(listItem.artists[0].name.length > 20)? listItem.artists[0].name.substring(0,20)+'...':listItem.artists[0].name }}</p>
              </div>
              <p
                class="list-rest__info-title"
                @click="()=>{goToSong(listItem.id)}"
              >
                {{ listItem.name.length > 60? listItem.name.substring(0,60)+'...':listItem.name }} 
              </p>
            </div>
           
            <transition name="custom-classes-transition"
              enter-active-class="animated fadeInRight"
              leave-active-class="animated fadeOutRight">
            <div 
            v-show="indexSocial === listItem.id && indexOfStart"
            class="share-positioner"
            key="social">
              <ShareComponent 
              :id="listItem.id"
              :name="listItem.name"
              />
            </div>
            </transition>
          </div>
           <transition name="custom-classes-transition"
              enter-active-class="animated fadeInRight"
              leave-active-class="animated fadeOutRight">
            <div 
            class="list-rest__info-button" 
            v-if="indexSocial !== listItem.id" 
            key="normal">
              <div class="list-rest__info-button-play">
                <i
                  v-show="listItem.mp3Path !== '' && listItem.mp3Path === actualPlay && isPlaying"
                  class="material-icons"
                  @click="playMP3(listItem.mp3Path)"
                >
                  pause_circle_outline
                </i>
                <i
                  v-if="listItem.mp3Path !== '' && listItem.mp3Path === actualPlay && !isPlaying"
                  class="material-icons"
                  @click="playMP3(listItem.mp3Path)"
                >
                  play_circle_outline
                </i>
                <i
                  v-if="listItem.mp3Path !== '' && listItem.mp3Path !== actualPlay"
                  class="material-icons"
                  @click="playMP3(listItem.mp3Path)"
                >
                  play_circle_outline
                </i>
              </div>
               <div
                class="list-rest__statistic-box"
                v-if="
                  (listDivide &&
                    listDivide[1] &&
                    index <
                      listDivide[0].numberOfSongs +
                        listDivide[1].numberOfSongs &&
                    indexOfStart) ||
                    indexOfStart && !special
                "
              >
                <div
                  tabindex="0"
                  :aria-label="'ostatnia pozycja' + listItem.lastPosition"
                >
                  Ostatnio
                </div>
                <p>{{ listItem.lastPosition }}</p>
              </div>
              <div
                class="list-rest__statistic-box"
                v-if="listDivide && listDivide[1] && index+1 < listDivide[0].numberOfSongs + listDivide[1].numberOfSongs &&  indexOfStart ||  indexOfStart"
              >
                <div>Zmiana</diV>
                <p>{{ listItem.changeFromLastWeek }}</p>
              </div>
              
              <div
                class="list-rest__symbol"
                v-if="indexOfStart"
              >
                <div
                  class="list-rest__symbol-up"
                  v-if="parseInt(listItem.changeFromLastWeek) > 0"
                >
                </div>
                <div
                  class="list-rest__symbol-zero"
                  v-if="parseInt(listItem.changeFromLastWeek) === 0"
                >
                </div>
                <div
                  class="list-rest__symbol-down"
                  v-if="parseInt(listItem.changeFromLastWeek) < 0"
                >
                </div>
              </div>
              <div
                class="list-rest__statistic-box"
                v-if="listDivide && index+1 < listDivide[0].numberOfSongs  && indexOfStart || indexOfStart"
              >
                <div v-if="top">{{top}}</diV>
                <p>{{ listItem.weeksOnList }}</p>
              </div>
              <div
                class="list-rest__button-container"
                v-if="!indexOfStart && canVote"
              >
                <SelectButton
                  buttonName="wybierz"
                  :action="()=>{addVote(listItem.id, listItem)}"
                  v-if="!indexOfStart && !listItem.isAlreadyVoted && !listItem.voteAdded"
                />
                <SelectButton
                  buttonName="wybrane"
                  :action="()=>{}"
                  v-if="!indexOfStart && listItem.isAlreadyVoted"
                />
                <SelectButton
                  buttonName="wybrane"
                  :action="()=>{removeVote(listItem.id, listItem)}"
                  v-if="!indexOfStart && !listItem.isAlreadyVoted && listItem.voteAdded"
                />
              </div>
            </div>
            </transition>
        </div>
        <button class="list-rest__button-normal toggle-button" v-if="indexSocial !== listItem.id && indexOfStart" @click="toggleSocialElement(listItem.id)"> 
          <i class="material-icons right-arrow" >
          keyboard_arrow_right
          </i>
        </button>
        <button class="list-rest__button-social toggle-button" v-else-if="indexSocial === listItem.id && indexOfStart" @click="toggleSocialElement(null)"> 
          <i class="material-icons left-arrow" >
          keyboard_arrow_left
          </i>
        </button>
      </div>
    </div>
    <div
      class="list-rest__show-rest"
      v-if="!showAll && indexOfStart"
    >
      <SelectButtonMobile
        buttonName="zobacz całe notowanie"
        :action="()=>{showAllSongs()}"
      />
    </div>
  </div>
</template>

<script>
import SelectButtonMobile from '@/ui/SelectButtonMobile';
import VoteCounterMobile from '@/ui/VoteCounterMobile';
import SelectButton from '@/ui/SelectButton'
import ShareComponent from '../../ShareComponent/Mobile/ShareComponent'
import mixin from '../mixin';

export default {
  mixins: [mixin],
  components: {
    SelectButtonMobile,
    VoteCounterMobile,
    ShareComponent,
    SelectButton
  }
}
</script>

<style scoped lang="scss">
  .list-rest {
    &__single-list-element {
      width: 100%;
      max-width: 700px;
      height: 10.625rem;
      background-color: #fefefe;
      margin: 1rem auto;
      display: flex;
      border-radius: 5px;
      position: relative;
    }
    &__index {
      height: 100%;
      width: 4rem;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
      background-color: #efeeee;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #acacac;
      font-family: 'Poppins', sans-serif;
      font-size: 2.5rem;
      font-weight: 700;
    }
    &__photo {
      width: 10.25rem;
      height: 100%;
      display: flex;
      justify-content: center;
      padding-top: 0.5rem;
    }
    &__photo-content {
      width: 8.5rem;
      height: 4.6875rem;
      box-sizing: border-box;
      border: 1px solid #e13368;
      position: relative;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100%;
    }
    &__photo-content-new {
      position: absolute;
      width: 3rem;
      height: 1rem;
      bottom: -0.5rem;
      left: 2.25rem;
      background-color: #41ae17;
      color: #fff;
      font-family: 'Poppins', sans-serif;
      font-size: 0.55rem;
      text-transform: uppercase;
      font-weight: 500;
      display: flex;
      justify-content: center;
      align-items: center;
      &:before {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        left: -0.5rem;
        bottom: 0;
        border-top: 0.5rem solid #2e7114;
        border-left: 0.5rem solid transparent;
      }
      &:after {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        right: -0.5rem;
        bottom: 0;
        border-top: 0.5rem solid #2e7114;
        border-right: 0.5rem solid transparent;
      }
    }
    &__info {
      height: 100%;
      display: flex;
    }
    &__info-content {
      width: 17rem;
      padding: 0.5rem 1rem;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      position: relative;
    }
    &__info-artist {
      font-family: 'Poppins', sans-serif;
      color: #0f1626;
      font-size: 1.2rem;
      line-height: 1.2;
      font-weight: 700;
      padding: 0 0.5rem 0.5rem 0;
      cursor: pointer;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &__info-title {
      font-family: 'Poppins', sans-serif;
      font-size: 1rem;
      color: #0f1626;
      cursor: pointer;
    }
    &__info-button {
      width: 100%;
      display: flex;
      align-items: center;
      position: absolute;
      bottom: 0;
      left: 4.875rem;
      i {
        color: #df2860;
        font-size: 2.7rem;
        cursor: pointer;
      }
    }
    &__info-button-play {
      width: 3rem;
    }
    &__info-button-social-media {
      width: 2.5rem;
      height: 2.5rem;
      background-image: url('/icons/media.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: 80%;
    }
    &__button {
      height: 100%;
      width: 11rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__button-container {
      height: 4.6875rem;
      width: 8.125rem;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-items: center;
    }
    &__button-statistic {
      display: flex;
    }
    &__statistic-box {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 6rem;
      p {
        color: #0f1626;
        font-family: 'Poppins', sans-serif;
        font-size: 0.9rem;
        font-weight: 700;
      }
      div {
        color: #0f1626;
        font-family: 'Poppins', sans-serif;
        font-size: 0.65rem;
        text-transform: uppercase;
        
      }
      
    }
    &__symbol {
      height: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1.5rem;
    }
    &__symbol-up {
      width: 0;
      height: 0;
      border-left: 0.5rem solid transparent;
      border-right: 0.5rem solid transparent;
      border-bottom: 0.7rem solid #4dc81d;
    }
    &__symbol-zero {
      width: 0.5rem;
      height: 0.5rem;
      background-color: #fbb101;
      border-radius: 100%;
    }
    &__symbol-down {
      width: 0;
      height: 0;
      border-left: 0.5rem solid transparent;
      border-right: 0.5rem solid transparent;
      border-top: 0.7rem solid #df2860;
    }
    &__show-rest {
      width: 100%;
      margin: 0 auto;
      max-width: 40rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    // &__waiting-room {
    //   background-color: #df2860;
    //   font-size: 1.1rem;
    //   text-transform: uppercase;
    //   height: 2.5rem;
    //   font-weight: 700;
    //   font-family: 'Poppins', sans-serif;
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    //   color: #fefefe;
    // }
    &__waiting-room {
      font-size: 1.1rem;
      text-transform: uppercase;
      height: 2.5rem;
      font-weight: 700;
      font-family: 'Poppins', sans-serif;
      display: flex;
      color: #fefefe;
      position: relative;
      margin-left: 1.5rem;
      align-items: center;
      color: #0f1626;
    }
    &__waiting-room:after {
      content: "";
      position: absolute;
      width: 1rem;
      height: 1rem;
      background-color: #df2860;
      left: -1.5rem;
    }
    .photoContentWithoutPhoto {
      background-image: url('/img/zaslepa.jpg') !important;
    }
    .fb-share-button {
      margin-right: 2rem;
    }
    .secondFirst {
      background-color: #af2f82;
      background-image: linear-gradient(to top, #df2860, #5541bd);
    }

    .toggle-button{
      margin-left: auto;
      border: none;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      max-width: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .left-arrow{
        color: white;
        font-size: 4rem;
      }
      .right-arrow{
        color: #dd2d62;
        font-size: 4rem;
      }
    }
    &__button-normal{
      background: #f5f2f2;
    }
    &__button-social{
      background-image: linear-gradient(to top, #df2860, #5541bd);
    }
  }

  .share-positioner{
    position: absolute;
    bottom: 5%;
    width: 100%;
  }

  //vote list

  .list-rest {
    &__single-list-element.vote-list {
      height: 5rem;
      justify-content: space-between;

      .list-rest__index{
        width: 5rem;
      }

      .list-rest__info-content{
        flex-direction: row;
        align-items: center;
        width: 100%;
        padding: 0;

        .list-rest__song-info{
          width: 55%;
        }
      }

      .list-rest__info{
        width: calc(100% - 6rem);
        margin: 0 auto;
      }

      .list-rest__info-button{
        width: 38%;
        height: 100%;
        justify-content: space-between;
        flex-direction: row-reverse;
        right: 0;
        left: auto;
        overflow: hidden;
            border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;


        &-play{
          background: #eeeeee;
          height: 100%;
          width: 4rem;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0.5rem 0;
          border-top-right-radius: 3px;
          border-bottom-right-radius: 3px;

        }
      }
    }

  }
.list-rest__statistic-box:not(:nth-child(2)) {
 
    border-left: 1px solid #f7f7f7;
  
}
</style>
